export default "__VITE_ASSET__HcBt81cg__"